import ArticleLayout from '@/components/feature/ArticleLayout';
import { articlesBySlug } from '@/mocks/articles';

export default function KakobuyZdjęciaQC() {
  return <ArticleLayout article={articlesBySlug['kakobuy-zdjecia-qc-poradnik']} />;
}